// $('<img src="//cdn.shopify.com/s/files/1/0161/0396/4772/t/15/assets/bottle_00_sp.png">,<img src="//cdn.shopify.com/s/files/1/0161/0396/4772/t/15/assets/bottle_00.png">').one('load', function () {
//   $('.swiper-slide-0 .slide_bottleShadow').css('visibility', 'visible');
// }).on('load');
$(document).ready(function () {

  const slide_names = [];
  $(".swiper-wrapper .swiper-slide").each(function (i) {
    slide_names.push($(this).find('.slide_name').text());
  });

  var now_hour = new Date().getHours();
    var targetClass;
    switch ( now_hour ) {
      case 0:
      case 12:
        targetClass = 6;
        break;
      case 1:
      case 13:
        targetClass = 7;
        break;
      case 2:
      case 14:
        targetClass = 8;
        break;
      case 3:
      case 15:
        targetClass = 9;
        break;
      case 4:
      case 16:
        targetClass = 10;
        break;
      case 5:
      case 17:
        targetClass = 11;
        break;
      case 6:
      case 18:
        targetClass = 0;
        break;
      case 8:
      case 20:
        targetClass = 2;
        break;
      case 9:
      case 21:
        targetClass = 3;
        break;
      case 10:
      case 22:
        targetClass = 4;
        break;
      case 11:
      case 23:
        targetClass = 5;
        break;
      default:
        targetClass = 1;
        break;
    }
  
  var mySwiper = new Swiper('.swiper-container', {
    loop: true,
    effect: 'fade',
    initialSlide: targetClass,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<div class="' + className + '"><span class="slide_pager-name">' + slide_names[index] + '</span></div>';
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  var moreArea = $('.slide_pager-more');
  $(function() {
    $(moreArea[targetClass]).addClass('active');
  })
  
  mySwiper.on('slideChange', function () {
    $('.slide_pager-more').removeClass('active').eq(mySwiper.realIndex).addClass('active');
  })
});